"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1495],{

/***/ 18016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



function Bio(param) {
    var showFitmentDisclaimer = param.showFitmentDisclaimer, imageUrl = param.imageUrl, name = param.name, quote = param.quote;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "bio",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "bio-details item",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "thumb-container",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                            objectFit: "contain",
                            width: "100px",
                            height: "100px",
                            src: imageUrl,
                            alt: "bio"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "text-container",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h4", {
                                children: [
                                    "Meet your Installation Tech, ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("blockquote", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "fas fa-quote-left"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                objectFit: "contain",
                                                width: "100px",
                                                height: "100px",
                                                src: imageUrl,
                                                alt: "bio"
                                            }),
                                            quote
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "disclaimer",
                                children: "Behind every installation is a person, we promote both independent and small businesses in your local community. Local For Local."
                            })
                        ]
                    })
                ]
            }),
            showFitmentDisclaimer && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "fitment-guarantee item",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "icon-container",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                            className: "fas fa-check-circle"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "text-container",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                children: "Fitment Guarantee"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "If there is any issue or question with product selection we will correct at time of delivery!"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "Additional Fees may apply at that time."
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Bio);


/***/ }),

/***/ 40456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_responsive_modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31190);
/* harmony import */ var _loading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38640);




var FeedbackModal = function(param) {
    var open = param.open, type = param.type, title = param.title, content = param.content, onCloseModal = param.onCloseModal, buttonConfirm = param.buttonConfirm, buttonDecline = param.buttonDecline, confirmAction = param.confirmAction, declineAction = param.declineAction, isLoading = param.isLoading;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "feedback-modal-container",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_responsive_modal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            classNames: {
                modal: "feedback-modal ".concat(type === "alert" ? "alert" : type === "info" ? "info" : ""),
                closeButton: "close-btn"
            },
            open: open,
            onClose: onCloseModal,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "inner",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "icon",
                        children: type === "alert" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                            className: "fas fa-exclamation-triangle"
                        }) : type === "info" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                            className: "fas fa-info-circle"
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                            className: "fas fa-info-circle"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "content",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                children: title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: content
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "buttons",
                                children: [
                                    buttonDecline && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        className: "btn btn-default",
                                        onClick: function() {
                                            return declineAction();
                                        },
                                        children: buttonDecline
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                        disabled: isLoading ? true : false,
                                        className: "btn btn-confirm",
                                        onClick: function() {
                                            return confirmAction("id");
                                        },
                                        children: [
                                            isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_loading__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: buttonConfirm
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FeedbackModal);


/***/ }),

/***/ 1278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ product_CampaignBanner; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(26626);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/static/images/logos/aaa-discount-rewards.png
/* harmony default export */ var aaa_discount_rewards = ({"src":"/_next/static/media/aaa-discount-rewards.60597615.png","height":187,"width":270,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAANlBMVEX////6+vvB1efZ5/K1y+FtnMeSsM+80ON4osmCqMz0hpGVtdTMo7X89PXpmaT5maH1l5/xjpmjIQ65AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAM0lEQVR4nBXHURaAIAhFwYuBDywt979ZT/M3wDu2LsDW+CYG9g9oLjV30aOqst88UZGZOhsSARJgqXXKAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./src/static/images/logos/AAA-logo.png
/* harmony default export */ var AAA_logo = ({"src":"/_next/static/media/AAA-logo.fdf76a06.png","height":500,"width":1000,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAJ1BMVEXJPT1FV5zwGivUITzgHTIJU53vGywHUJkBU5zsHS23J0TvGynoHC7nZ/E1AAAADXRSTlMCDbM0akxwI4FfeoJ/4WRwMgAAAAlwSFlzAAALEwAACxMBAJqcGAAAACZJREFUeJwVxccRADAIBLHlSE791+vhI8GuilyNS5IbcN6N2XKEDwlWAGoDLQQIAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":4});
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/react-responsive-modal/dist/react-responsive-modal.esm.js + 3 modules
var react_responsive_modal_esm = __webpack_require__(31190);
// EXTERNAL MODULE: ./node_modules/react-text-mask/dist/reactTextMask.js
var reactTextMask = __webpack_require__(91749);
var reactTextMask_default = /*#__PURE__*/__webpack_require__.n(reactTextMask);
// EXTERNAL MODULE: ./node_modules/simple-react-validator/dist/simple-react-validator.min.js
var simple_react_validator_min = __webpack_require__(41283);
var simple_react_validator_min_default = /*#__PURE__*/__webpack_require__.n(simple_react_validator_min);
;// CONCATENATED MODULE: ./src/components/modals/AAAModal.jsx
var _this = undefined;









var SET_PRICELEVEL = "pricelevel/SET_PRICELEVEL";
var AAAModel = function(param) {
    var open = param.open, type = param.type, title = param.title, content = param.content, onCloseModal = param.onCloseModal, buttonConfirm = param.buttonConfirm, buttonDecline = param.buttonDecline, priceLevel = param.priceLevel;
    var dispatch = (0,es/* useDispatch */.I0)();
    var validator = (0,react.useRef)(new (simple_react_validator_min_default())({
        autoForceUpdate: _this,
        locale: "en"
    }));
    var ref = (0,react.useState)(), membershipID = ref[0], setmembershipID = ref[1];
    var ref1 = (0,react.useState)(), memberName = ref1[0], setMemberName = ref1[1];
    var assignProductPriceLevel = function(priceLevel) {
        if (validator.current.allValid()) {
            dispatch({
                type: SET_PRICELEVEL,
                payload: {
                    priceLevel: priceLevel
                }
            });
            return true;
        } else {
            validator.current.showMessages();
            return false;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "feedback-modal-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_responsive_modal_esm/* default */.Z, {
            classNames: {
                modal: "feedback-modal ".concat(type === "alert" ? "alert" : type === "info" ? "info" : ""),
                closeButton: "close-btn"
            },
            open: open,
            onClose: onCloseModal,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "inner",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "icon",
                        children: type === "alert" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "fas fa-exclamation-triangle"
                        }) : type === "info" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "fas fa-info-circle"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "fas fa-info-circle"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: content
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "aaa-card mb-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "header",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "logo-container",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: AAA_logo,
                                                    alt: "logo"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "contact-info",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "For Help Call:"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "1-800-BATTERY"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "(1-800-228-8379)"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "body",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "forms-container",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "form-row",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                className: "control-label",
                                                                children: "Your AAA Membership ID ( 16 Digits )"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((reactTextMask_default()), {
                                                                guide: false,
                                                                mask: [
                                                                    /[1-9]/,
                                                                    /\d/,
                                                                    /\d/,
                                                                    " ",
                                                                    /\d/,
                                                                    /\d/,
                                                                    /\d/,
                                                                    " ",
                                                                    /\d/,
                                                                    /\d/,
                                                                    /\d/,
                                                                    /\d/,
                                                                    /\d/,
                                                                    /\d/,
                                                                    /\d/,
                                                                    /\d/,
                                                                    /\d/,
                                                                    " ",
                                                                    /\d/, 
                                                                ],
                                                                onChange: function(event) {
                                                                    setmembershipID(event.target.value);
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "validator-message-container",
                                                        children: validator.current.message("Membership Number", membershipID, [
                                                            "required",
                                                            {
                                                                size: 19
                                                            }, 
                                                        ])
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "form-row mb-0",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                className: "control-label",
                                                                children: "First and Last Name"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                className: "form-control",
                                                                value: memberName,
                                                                onChange: function(event) {
                                                                    setMemberName(event.target.value);
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "validator-message-container",
                                                        children: validator.current.message("Member Name", memberName, "required")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "rewards-logo",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: aaa_discount_rewards,
                                                    alt: "rewards"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "buttons",
                                children: [
                                    buttonDecline && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "btn btn-default",
                                        onClick: function() {
                                            return onCloseModal();
                                        },
                                        children: buttonDecline
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "btn btn-confirm",
                                        onClick: function() {
                                            var result = assignProductPriceLevel(priceLevel);
                                            if (result == true) {
                                                onCloseModal();
                                            }
                                        },
                                        children: buttonConfirm
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var AAAModal = (AAAModel);

// EXTERNAL MODULE: ./src/components/modals/FeedbackModal.jsx
var FeedbackModal = __webpack_require__(40456);
;// CONCATENATED MODULE: ./src/components/product/CampaignBanner.jsx











var CampaignBanner = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(CampaignBanner, Component);
    var _super = (0,_create_super/* default */.Z)(CampaignBanner);
    function CampaignBanner(props) {
        (0,_class_call_check/* default */.Z)(this, CampaignBanner);
        var _this;
        _this = _super.call(this, props);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "onOpenModal", function() {
            _this.setState({
                modalTermsOfServiceOpen: true
            });
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "onCloseAAAModal", function() {
            setTimeout(function() {
                _this.setState({
                    aaaMemberShipPrompt: false
                }, function() {
                    console.log(this.state.aaaMemberShipPrompt, "aaaMemberShipPrompt");
                });
            }, 1);
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "onCloseModal", function() {
            setTimeout(function() {
                _this.setState({
                    modalTermsOfServiceOpen: false
                }, function() {
                    console.log(this.state.modalTermsOfServiceOpen, "modalTermsOfServiceOpen");
                });
            }, 1);
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "onOpenAAAModal", function() {
            _this.setState({
                aaaMemberShipPrompt: true
            });
        });
        _this.state = {
            modalTermsOfServiceOpen: false,
            termsOfServiceContent: "",
            aaaMemberShipPrompt: false,
            test: 0
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(CampaignBanner, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var campaigns = this.props.campaigns;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "discounts",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FeedbackModal/* default */.Z, {
                            open: this.state.modalTermsOfServiceOpen,
                            type: "info",
                            title: "Terms of Service",
                            content: this.state.termsOfServiceContent,
                            onCloseModal: this.onCloseModal,
                            confirmAction: this.onCloseModal,
                            buttonConfirm: "OK"
                        }),
                        campaigns && campaigns.map(function(item, index) {
                            if (item.campaignType === 1) {
                                if (!item.redirectURL) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "discount-item",
                                        onClick: function() {
                                            return _this.setState({
                                                modalTermsOfServiceOpen: true,
                                                termsOfServiceContent: item.terms
                                            });
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "content",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "amount",
                                                    children: item.discountAmount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "amount",
                                                        children: [
                                                            "$",
                                                            item.discountAmount,
                                                            " OFF - "
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "details",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "mr-1",
                                                            children: item.campaignText
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            width: "100px",
                                                            height: "100px",
                                                            objectFit: "contain",
                                                            src: item.campaignImageUrl,
                                                            alt: ""
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }, index);
                                } else {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "discount-item",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: item.redirectURL,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "content",
                                                children: [
                                                    item.discountAmount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "amount",
                                                        children: [
                                                            "$",
                                                            item.discountAmount,
                                                            " OFF - "
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "details",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "mr-1",
                                                                children: item.campaignText
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                width: "100px",
                                                                height: "100px",
                                                                objectFit: "contain",
                                                                src: item.campaignImageUrl,
                                                                alt: ""
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }, index);
                                }
                            }
                            if (item.campaignType === 5) {
                                // AAA Membershipship Prompt
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "discount-item",
                                    onClick: function() {
                                        return _this.setState({
                                            aaaMemberShipPrompt: true,
                                            termsOfServiceContent: item.terms
                                        });
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AAAModal, {
                                            open: _this.state.aaaMemberShipPrompt,
                                            type: "info",
                                            title: "Verify AAA Membership",
                                            content: item.terms,
                                            onCloseModal: _this.onCloseAAAModal,
                                            confirmAction: _this.onCloseAAAModal,
                                            declineAction: _this.onCloseAAAModal,
                                            buttonConfirm: "OK",
                                            buttonDecline: "Cancel",
                                            priceLevel: item.priceLevel
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "content",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "amount",
                                                    children: item.discountAmount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "amount",
                                                        children: [
                                                            "$",
                                                            item.discountAmount,
                                                            " OFF - "
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "details",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "mr-1",
                                                            children: item.campaignText
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            width: "100px",
                                                            height: "100px",
                                                            objectFit: "contain",
                                                            src: item.campaignImageUrl,
                                                            alt: ""
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }, index);
                            } else return "";
                        })
                    ]
                });
            }
        }
    ]);
    return CampaignBanner;
}(react.Component);
/* harmony default export */ var product_CampaignBanner = (CampaignBanner);


/***/ })

}]);